module.exports = __webpack_public_path__ + "static/media/logo＿green.f7df2447.svg";